import styled, { css } from "styled-components";

export const TopUpPageContainer = styled.div`
  width: 1342px;
  margin: 0px auto 20px;
  padding-bottom: 18px;
  position: relative;
  z-index: 0;
`;
export const TopUpContainer = styled.div`
  display: flex;
  height: 100%;
  border: 1px solid #343538;
  border-radius: 4px;
  background: #292b2f;
  .renderbus-ui-tab {
    flex: 1 1 0%;
    max-width: 1012px;
  }
`;

export const UserInfoContainer = styled.div`
  width: 330px;
  border-left: 1px solid #3a4449;
  padding: 24px 16px;
  background: #2c2e32;
  box-shadow: -11px 0px 8px 0px #0000001a;
`;

export const AnimationCommonContainer = styled.div`
  padding: 20px;
`;

export const FoxCommonCardListWrapper = styled.div<{
  mT?: string;
  pT?: string;
}>`
  display: flex;
  margin-top: ${(p) => p.mT || "0px"};
  padding-top: ${(p) => p.pT || "12px"};
  padding-bottom: ${(p) => p.pT || "12px"};
  overflow: auto;
  gap: 14px;
`;

export const CommonSecondTabsContent = styled.div`
  border: 1px solid #495359;
  border-radius: 4px;
  .renderbus-ui-tab {
    border-radius: 4px;
  }
`;

export const CommonTitle = styled.div`
  color: #e8eef9;
  font-size: 14px;
  font-weight: 600;
`;

export const CommonUpperPart = styled.div`
  min-height: 330px;
`;

export const beforeCss = css`
  ::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: inherit;
    padding: 4px;
    box-sizing: border-box;
    background: linear-gradient(104.4deg, #f3512b 2.85%, #ee9b52 100%);
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: destination-out;
    mask-composite: exclude;
  }
`;

export const CommonCornerMark = styled.div`
  position: absolute;
  left: 0px;
  top: -12px;
  height: 26px;
  padding: 4px 12px;
  background: linear-gradient(104.4deg, #f3512b 2.85%, #ee9b52 100%);
  /* background: linear-gradient(90deg, #2edb8a 0%, #13c5cb 100%); */
  border-radius: 6px 2px 6px 0px;
  color: #ffffff;
  font-weight: 600;
  font-size: 12px;
`;
